/* unplugin-vue-components disabled */import { render } from "./takeDiss.vue?vue&type=template&id=361286ce&scoped=true"
import script from "./takeDiss.vue?vue&type=script&lang=js"
export * from "./takeDiss.vue?vue&type=script&lang=js"

import "./takeDiss.vue?vue&type=style&index=0&id=361286ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361286ce"]])

export default __exports__